import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=31d26aa5&scoped=true&"
import script from "./TransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d26aa5",
  null
  
)

export default component.exports